export const TRACTORS = "TRACTORS";
export const SELECTED_TRACTOR = "SELECTED_TRACTOR";
export const TRACTOR_COUNT = "TRACTOR_COUNT";
export const TRAILERS = "TRAILERS";
export const TRAILER_COUNT = "TRAILER_COUNT";
export const TRACTOR_LOCATIONS = "TRACTOR_LOCATIONS";
export const SELECTED_TRAILER = "SELECTED_TRAILER";
